import certificate from "@/service/certificate.api";

const state = {
};

const mutations = {
};

const getters = {
};

const actions = {

  async GetInvestCert({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await certificate.GetInvestCert(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  async GetCertificate({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await certificate.GetCertificate(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  async DownloadCertificate({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await certificate.DownloadCertificate(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
